import { FC, SVGProps } from 'react';

const MenuToggleIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#7A7A7A',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5148 2.5H6.48594C4.02919 2.5 2.5 4.23432 2.5 6.68865V13.3113C2.5 15.7657 4.02919 17.5 6.48676 17.5H13.5148C15.9716 17.5 17.5 15.7657 17.5 13.3113V6.68865C17.5 4.23432 15.9643 2.5 13.5148 2.5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33325 7.5L5.83325 10.0015L8.33325 12.5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 2.55542V17.4512"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MenuToggleIcon;
